import LandingAutoSuggest from './LandingAutoSuggest';

export default LandingAutoSuggest;
